export default {
  data() {
    return {
      projects: [
        {
          title: 'Concert in The Clouds',
          members: ['Chaterine Andreas', 'James Henry P.', 'Vianka'],
          brief:
            'Generate a creative solution to boost business for Malaysia Airlines during the&nbsp;pandemic.',
          problem:
            'People who are looking forward to attend their favorite artist concert has to shut down their dreams as most of the concerts are&nbsp;cancelled.',
          insight: '',
          idea:
            'Malaysia Airlines will introduce a one of a kind concert experience in their planes that will tour the artist from one country to&nbsp;another.',
          carousel: [
            {
              id: 0,
              caption: 'Book your tickets with Malaysia Airlines’ app',
              src: 'img0.jpg',
              tag: 'img',
            },
            {
              id: 1,
              caption: 'Get to the flight',
              src: 'img1.jpg',
              tag: 'img',
            },
            {
              id: 2,
              caption: 'Enjoy the concert',
              src: 'img2.jpg',
              tag: 'img',
            },
            {
              id: 3,
              caption: 'Get personal with the artist',
              src: 'img3.jpg',
              tag: 'img',
            },
            {
              id: 4,
              caption: 'Get exclusive merchandise',
              src: 'img4.jpg',
              tag: 'img',
            },
            {
              id: 5,
              caption:
                'Supporting media such as instagram story ad and facebook post to promote this&nbsp;campaign',
              src: 'img5.jpg',
              tag: 'img',
            },
          ],
          heading: 'How it Works',
          video: 'https://www.youtube.com/embed/Mz1bBupEnyE',
        },
        {
          title: 'Mama Miss You',
          members: ['Aurelius Kevin', 'Seow Wei Hang', 'Liew Kar Mun'],
          brief:
            'Malihom is facing a problem due to the Covid-19 pandemic. People are obliged to stay at their own home and Malihom need to recover in terms&nbsp;of&nbsp;sales.',
          problem:
            'People still prefer to stay at home, even though the MCO is&nbsp;loosen.',
          insight: '',
          idea:
            'We depict the nature as a “mother” that missing her child due to this pandemic and want them to come&nbsp;“home”.',
          carousel: [
            {
              id: 0,
              caption:
                'We will post a testimony video about a mother who misses her&nbsp;children.',
              src: 'img0.mp4',
              tag: 'video',
            },
            {
              id: 1,
              caption: 'You can listen on the radio.',
              src: 'img1.jpg',
              tag: 'img',
            },
            {
              id: 2,
              caption:
                'The message would be delivered as social media posting such as Instagram story, Facebook&nbsp;Carousel.',
              src: 'img2.jpg',
              tag: 'img',
            },
            {
              id: 3,
              caption: 'We also have a Website Pop Up Promotional.',
              src: 'img3.jpg',
              tag: 'img',
            },
          ],
          heading: 'How it Works',
          video: 'https://www.youtube.com/embed/bUmzTKpaa9Q',
        },
        {
          title: 'Unlock Your Space',
          members: ['How Hui San', 'Lau Wai Yee', 'Ho Nguyen Phuong Anh'],
          brief:
            'To generate a creative idea to bring the sale up during the Covid-19&nbsp;pandemic.',
          problem:
            'Due to the coronavirus outbreak, property buyers are reluctant to go out and visit showrooms, even during the recovery movement control order. Due to this, property companies need an innovative and memorable way to reach out to their&nbsp;audience.',
          insight: '',
          idea:
            'We launch a virtual showroom disguised as an online exploration game with real prizes to drive the traffic back to our real&nbsp;showroom.',
          carousel: [
            {
              id: 0,
              caption:
                'People can visit our microsite to try this game. Entering the game, players will find themselves stuck in the main&nbsp;bedroom.',
              src: 'img0.jpg',
              tag: 'img',
            },
            {
              id: 1,
              caption:
                'Players can interact with the objects in the room. In order to unlock the next area, they have to find the keys hidden in various&nbsp;places.',
              src: 'img1.jpg',
              tag: 'img',
            },
            {
              id: 2,
              caption:
                'Eventually, players will be able to unlock the entire house, which is Zentro residences’ actual layout. Now they can go about and view it&nbsp;properly.',
              src: 'img2.jpg',
              tag: 'img',
            },
            {
              id: 3,
              caption:
                'Certain challenges will reward players with special prizes for the new home. Which they can collect at Zentro’s official&nbsp;showroom.',
              src: 'img3.jpg',
              tag: 'img',
            },
            {
              id: 4,
              caption:
                'After finishing the game, players are encouraged to book a meeting with Zentro’s agents for more information about the&nbsp;apartment.',
              src: 'img4.jpg',
              tag: 'img',
            },
            {
              id: 5,
              caption:
                'To promote this game, several digital ads will be launched on social&nbsp;media.',
              src: 'img5.jpg',
              tag: 'img',
            },
          ],
          heading: 'How it Works',
          video: 'https://www.youtube.com/embed/xW-VF1TqVWA',
        },
        {
          title: 'ROCKTIFY',
          members: ['Samantha Lung', 'Tan Zhi Jian', 'Goh Sze Chien'],
          brief:
            'Generate a creative solution to boost business for Hard Rock Hotel during&nbsp;pandemic.',
          problem:
            'Since the coronavirus outbreak, around 15% of Malaysian hotels are believed that they will not survive the MCO and will have to close completely. Hard Rock hotel needs to come out with an interesting campaign to draw young customers in after the MCO is&nbsp;lifted.',
          insight: '',
          idea:
            'We created giant “Rock”albums in 3 major shopping malls around KL that contains a Spotify code that allows users to download famous rock songs from a variety of rock genres. By scanning all 3 rock albums, our audience will be able to get a special discount to book a stay at our&nbsp;hotel.',
          carousel: [
            {
              id: 0,
              caption: 'Scan the Spotify code on the rock',
              src: 'img0.jpg',
              tag: 'img',
            },
            {
              id: 1,
              caption: 'Collect all the playlist',
              src: 'img1.jpg',
              tag: 'img',
            },
            {
              id: 2,
              caption: 'Get a discount voucher for Hard Rock Hotel',
              src: 'img2.jpg',
              tag: 'img',
            },
            {
              id: 3,
              caption: 'Enjoy a nice stay',
              src: 'img3.jpg',
              tag: 'img',
            },
            {
              id: 4,
              caption: 'Facebook Carousel Ad',
              src: 'img4.jpg',
              tag: 'img',
            },
            {
              id: 5,
              caption: 'Digital Poster around the mall',
              src: 'img5.gif',
              tag: 'img',
            },
          ],
          heading: 'How it Works',
          video: 'https://www.youtube.com/embed/tFSKYlMbRQQ',
        },
        {
          title: 'The Tigers That Won’t Return',
          members: ['Chaterine Andreas', 'Ho Nguyen Phuong Anh', 'Vianka'],
          problem:
            'Malayan tigers have been classified as “Critically Endangered’ species under the IUCN Red List, with less than 200 left in the wild today. It is expected that they will face extinction in the next two to three years if no action is taken right&nbsp;now.',
          insight:
            "Malaysian care a lot about a soccer team called “Malayan Tigers” but not so much for the real tigers. They think Malayan tigers' problems are irrelevant and there’s nothing much they can do to&nbsp;help.",
          idea:
            'Malaysia’s national football team is called Harimau Malaya in reference to the Malayan tiger. Since Malaysia is crazy about football, we want to use this to shift their attention toward the real Malayan tigers. We will let the audience experience how it feels like to lose all the “Harimau Malaya” in such a short period of&nbsp;time.',
          carousel: [
            {
              id: 0,
              caption:
                'We will pull off a live stunt during a friendly football match between the national team and another state’s&nbsp;team',
              src: 'img0.jpg',
              tag: 'img',
            },
            {
              id: 1,
              caption:
                'Red cards will be given by the referee out of the blue, eliminating players from the Harimau Malaya one by one until there is only the goalkeeper&nbsp;left',
              src: 'img1.jpg',
              tag: 'img',
            },
            {
              id: 2,
              caption:
                'Everything will be done in the first two minutes of the match to show that in the next 2 years, the real tigers will be gone too. An announcement will appear once all the players are&nbsp;eliminated',
              src: 'img2.jpg',
              tag: 'img',
            },
            {
              id: 3,
              caption:
                'The announcement will explain how fast Malayan tigers are dying in the wild, and if there is no tiger in real life then the “Harimau Malaya” means little to&nbsp;nothing',
              src: 'img3.jpg',
              tag: 'img',
            },
            {
              id: 4,
              caption:
                'People will be encouraged to visit a link to donate to WWF fund to save the tigers. After the donation has been made, the match will go back to&nbsp;normal',
              src: 'img4.jpg',
              tag: 'img',
            },
          ],
          heading: 'How it Works',
          video: 'https://www.youtube.com/embed/4cPV544y2Dc',
        },
        {
          title: 'Tree of Ash',
          members: ['Aurelius Kevin', 'James Henry P.'],
          brief:
            'Pollution in Malaysia is one of the worst in the world. So, we want to educate people to be more aware and considerate about their contribution to air&nbsp;pollution.',
          problem:
            'Carbon emission has always been a big problem for Malaysia and the world. Human activities caused terrible air pollution and people are not aware of how significant their contribution is to air pollution. People have no idea how they can help to protect the environment without getting out of their comfort in everyday&nbsp;life.',
          insight: '',
          idea:
            'Installation by using bonsai trees made with ash from certain pollutants to educate people how long a tree requires to absorb carbon emissions caused by human activities. We need to let them know that trees are needed to support us in cleaning up carbon emissions in the&nbsp;air.',
          carousel: [
            {
              id: 0,
              caption: '',
              src: 'img0.jpg',
              tag: 'img',
            },
          ],
          heading: 'How it Works',
          video: '',
        },
        {
          title: 'Eco Pack',
          members: ['Samantha Lung', 'Liew Kar Mun', 'Lau Wai Yee'],
          brief:
            'As online shopping and food delivery grows in popularity throughout the country, and on the continent as a whole, the effects of mounting waste from these services is sparking the push for more effective policies from the government towards white pollution. Due to the need for disposable packaging to transport food, the food delivery service inherently produces a large amount of white&nbsp;pollution.',
          problem:
            'In Malaysia, there are about 26 million tonnes of garbage wastage being disposed to landfills every year. For a long time now, the garbage pollution has been harmful to the environment on out planet. Unfortunately, most of the garbage waste comes from fast food&nbsp;packaging.',
          insight: '',
          idea:
            'Being one of the responsible fast food chain, McDonald’s Malaysia decided to tackle the issue by creating an all-in-one package called the EcoPack. A reusable and foldable packaging that stops the paper wastage, and it’s also an easier way to transport your&nbsp;food.',
          carousel: [
            {
              id: 0,
              caption:
                'This foldable packaging comes with dividers to separate your food and is able to fit a lot of items. It is also washable and reusable. Each time consumer brings the package to McDonald’s to order food, they will get 20%&nbsp;discount!',
              src: 'img0.jpg',
              tag: 'img',
            },
            {
              id: 1,
              caption:
                'This foldable packaging comes with dividers to separate your food and is able to fit a lot of items. It is also washable and reusable. Each time consumer brings the package to McDonald’s to order food, they will get 20%&nbsp;discount!',
              src: 'img1.jpg',
              tag: 'img',
            },
            {
              id: 2,
              caption:
                'This foldable packaging comes with dividers to separate your food and is able to fit a lot of items. It is also washable and reusable. Each time consumer brings the package to McDonald’s to order food, they will get 20%&nbsp;discount!',
              src: 'img2.jpg',
              tag: 'img',
            },
            {
              id: 3,
              caption:
                'This foldable packaging comes with dividers to separate your food and is able to fit a lot of items. It is also washable and reusable. Each time consumer brings the package to McDonald’s to order food, they will get 20%&nbsp;discount!',
              src: 'img3.jpg',
              tag: 'img',
            },
          ],
          heading: 'How it Works',
          video: '',
        },
        {
          title: 'The Untold Fact',
          members: ['Seow Wei Hang', 'How Hui San', 'Joanna Lai'],
          brief:
            'Pollution in Malaysia is one of the worst in the world. Smoking is one of the air pollution. So, we want to expose the truth to the&nbsp;smokers.',
          problem:
            'Kuala Lumpur has more than 23 million vehicles moving on the road every day. The amount of polluted air released by the vehicles is causing the city to become one with the highest API in the region. Even though smokers hate pollution caused by vehicles. Sadly, they are unaware that smoking is&nbsp;worse.',
          insight: '',
          idea:
            'To tackle the insight and to reduce air pollution in Kuala Lumpur, Malaysia Quit Smoking Clinic has released a youtube video to expose the truth that smokers contribute 10 times more to air pollution and eventually to convince smokers to quit smoking and reduce air&nbsp;pollution.',
          carousel: [
            {
              id: 0,
              caption: '',
              src: 'img0.mp4',
              tag: 'video',
            },
          ],
          heading: 'Youtube Ad',
          video: 'https://www.youtube.com/embed/LXXwUPXFMuA',
        },
        {
          title: 'Chari-Tiger-Able Logo of the Day',
          members: ['Jack Tan', 'Leong Jing Er', 'Tan Zhi Jian', 'Mah Yue Nam'],
          problem:
            'Malayan Tigers are expected to be extinct by 2022. This is due to a number of factors which includes deforestation which leads to habitat loss, illegal poaching for tiger parts that are used for clothing and Chinese medicine, human and tiger conflicts in rural areas and many&nbsp;more.',
          insight:
            'Malaysians are proud of their national symbol, the Malayan tigers, which is why tiger motifs are often used in the country, The Malayan tiger represents the nation’s strength. However, when Malaysia as their national icon, the representation of their pride and willpower would no longer be&nbsp;relevant.',
          idea:
            'On Global Tigers Day, HSBC will announce its new logo which will only be used on that special day to raise awareness on the endangered Malayan tigers. The logo will feature a Malayan tiger which resembles a certain brand to create talkability and bring in more people to help preserve the Malayan tiger population in&nbsp;Malaysia.',
          carousel: [
            {
              id: 0,
              caption: '',
              src: 'img0.jpg',
              tag: 'img',
            },
            {
              id: 2,
              caption: '',
              src: 'img1.jpg',
              tag: 'img',
            },
          ],
          heading: 'How it Works',
          video: '',
        },
      ],
    };
  },
};
